module.exports = __webpack_public_path__ + "static/img/far2.efc6ad98.png";